import { DolfinDiagram } from '../diagram'
import DolfinFlowExecutor from '../flow-executor/base'
import { NodeError, NodeWarning } from '../types'
import { DolfinNode } from './base'
import { TypedNode } from './types'

/**
 * Branch By User node - routes execution based on user-specific attributes.
 *
 * @see /docs/domain/nodes/branch-by-user.md for canonical documentation
 */
export class BranchByUserNode extends DolfinNode<DolfinFlowExecutor, 'branch-by-user'> {
  async process(): Promise<number> {
    if (this.formData.filters && Array.isArray(this.formData.filters)) {
      for (const [index, filter] of this.formData.filters.entries()) {
        if (!!filter) {
          await this.loadUserFields(filter.data ?? [])

          if (!filter.data || this.evaluateLogic(filter.data)) {
            console.info('Path #', index + 1)
            return index
          }
        }
      }
    }

    return -1
  }

  async parse(_diagram: DolfinDiagram) {
    return this.node
  }

  static validate(
    node: TypedNode<'branch-by-user'>,
    diagram: DolfinDiagram
  ): {
    errors: NodeError[]
    warnings: NodeWarning[]
  } {
    const superValidation = super.validate(node, diagram)

    const hasFilters = node.data.formData?.filters

    if (!hasFilters) {
      superValidation.errors.push({
        message: 'Branch by user node must have filters',
        node
      })
    }

    if (hasFilters) {
      for (const filter of hasFilters) {
        if (!Object.keys(filter.data ?? {}).length) {
          superValidation.errors.push({
            message: 'Branch by user node must have filters',
            node
          })
        }

        // Make it recursive
        const hasValues = Object.values(filter.data ?? {}).some(
          v => v !== null && v !== undefined && v !== '' && Array.isArray(v) && v.length > 0
        )

        if (!hasValues) {
          superValidation.errors.push({
            message: 'Branch by user node must have values',
            node
          })
        }
      }
    }

    return {
      errors: [...superValidation.errors],
      warnings: [...superValidation.warnings]
    }
  }
}
